import React from 'react';
import KickImage from 'Reuseables/KickImage';
import { Link } from 'react-router-dom';
import classNames from 'classnames';
import { Button, Modal, InputGroup, Input, FormGroup, Form } from 'reactstrap';
import { convertToRupiah, hasError } from '../../utils';
import { FormFeedback } from '../Forms';

const isDisabled = (value) => {
  return value == 0 || parseInt(value) < 100000
}

const ModalTopUp = props => (
  <Modal modalClassName="modal-topup" 
    isOpen={props.isOpen} 
    toggle={props.onToggle}
  >
    <div className="topup-header">
      <p>TOP UP</p>
    </div>
    <Form className="topup-content" onSubmit={ e=> {
          e.preventDefault();
          if(!isDisabled(props.amount)) props.onNextPage(2);
        }}>
      <div className="text-desc">
        <p>Input the amount that you desire to top up</p>
      </div>
      <FormGroup className="topup-input">
        <InputGroup 
          className={classNames({"is-invalid": hasError(props.error && props.error.errors, "amount")})}
        >
        {
          window.screen.availWidth > 480 ?
          <Input 
            value={convertToRupiah(parseInt(props.amount))}
            onChange={props.onTextChange} 
            name="_amount"
          /> :
          <Input 
            value={convertToRupiah(parseInt(props.amount))}
            onChange={props.onTextChange} 
            name="_amount"
            type="tel"
          />
        }
        </InputGroup>
        <FormFeedback errors={props.error && props.error.errors} field="amount"/>
        <p>Minimal Top Up 100.000</p>
      </FormGroup>
      <div className="text-desc3">
        <p>Payments done by Kick Wallet will be free of any administration charges and will be processed instantly.</p>
      </div>
      <div className="topup-button">
        <Button 
          className={classNames("topup-content", {"btn": props.amount>0, "btn2": isDisabled(props.amount)})} 
          disabled={isDisabled(props.amount)}
          onClick={() => props.onNextPage(2)}
        >
          Next
        </Button>
      </div>
    </Form>     
  </Modal>
)

export default ModalTopUp;